import ModelUtil from '@leverege/model-util'

function create( content = null ) {
  return {
    name : null,
    alias : null,
    description : null,
    discoveryUrl : null,
    clientId : null,
    clientSecret : null,
    scope : null,
    allowUserCreation : null,
  }
}

module.exports = {
  create,
  ...ModelUtil.createAllValue( 'name' ),
  ...ModelUtil.createAllValue( 'alias' ),
  ...ModelUtil.createAllValue( 'description' ),
  ...ModelUtil.createAllValue( 'discoveryUrl' ),
  ...ModelUtil.createAllValue( 'clientId' ),
  ...ModelUtil.createAllValue( 'clientSecret' ),
  ...ModelUtil.createAllValue( 'scope' ),
  ...ModelUtil.createAllValue( 'allowUserCreation' ),
}
